module.exports = __webpack_public_path__ + "img/xander-opcion-1.f4a78ff3.png";